import _ from 'lodash'
import type {ReadOnlyExtensionAPI} from '../../types'
import {SemanticTypes} from '../../preprocess/conversionDataBuilders'

const SEMANTIC_TYPE_TO_TRANSFORMER: Partial<
    Record<SemanticTypes, (data: any, readOnlyExtensionAPI: ReadOnlyExtensionAPI, componentType: string) => void>
> = {
    [SemanticTypes.TEXT]: (data: any, readOnlyExtensionAPI: ReadOnlyExtensionAPI, componentType: string) => {
        const mainText = readOnlyExtensionAPI.getMainTextField(componentType, data)
        if (mainText) {
            data.text = mainText
        }
    }
}

export const transformComponentData = (
    data: any,
    semanticType: SemanticTypes,
    readOnlyExtensionAPI: ReadOnlyExtensionAPI,
    componentType?: string
) => {
    const transformedData = _.cloneDeep(data?.data ?? data ?? {})
    if (componentType) {
        const transformer = SEMANTIC_TYPE_TO_TRANSFORMER[semanticType]
        transformer?.(transformedData, readOnlyExtensionAPI, componentType)
    }
    return transformedData
}
